/* src/app/workshop-scheduler/pages/scheduler-hours/scheduler-hours.component.scss */
.schedBar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}
.schedHeading {
  margin: 0 0.4rem 0 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #006498;
  white-space: nowrap;
}
.barDate,
.barBtn {
  height: 30px;
  border: 1px solid #cbd5e1;
  background: white;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}
.barBtn {
  padding: 0 0.7rem;
  white-space: nowrap;
  cursor: pointer;
}
.barBtn:hover:not(:disabled) {
  border-color: #f99420;
  background: #fff7ed;
}
.barBtn:disabled {
  opacity: 0.45;
  cursor: default;
}
.barBtn.on {
  background: #24333f;
  border-color: #24333f;
  color: white;
}
.barDate {
  padding: 0 0.4rem;
}
.schedNav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
}
.schedNav .navBtn {
  width: 30px;
  padding: 0;
}
.schedNav .schedTitle {
  min-width: 12rem;
  text-align: center;
  font-size: 0.9rem;
}
.seg {
  display: inline-flex;
  height: 30px;
}
.seg .segBtn {
  border: 1px solid #cbd5e1;
  border-left-width: 0;
  background: white;
  padding: 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}
.seg .segBtn:first-child {
  border-left-width: 1px;
  border-radius: 6px 0 0 6px;
}
.seg .segBtn:last-child {
  border-radius: 0 6px 6px 0;
}
.seg .segBtn:hover:not(.on) {
  background: #f1f5f9;
}
.seg .segBtn.on {
  background: #006498;
  border-color: #006498;
  color: white;
}
.hoursPage {
  position: fixed;
  top: 3.5rem;
  left: 4.5rem;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: #eef1f4;
}
.barField {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
}
.barBtn.primary {
  background: #006498;
  border-color: #006498;
  color: white;
}
.hoursBody {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem 1rem 2rem;
}
.hoursBody.busy .acc {
  pointer-events: none;
  opacity: 0.75;
}
.closedText {
  font-size: 0.78rem;
  color: #64748b;
}
.hint {
  font-size: 0.78rem;
  color: #64748b;
  margin: 0 0 0.6rem;
}
.blk {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.6rem;
  padding: 0.8rem 1rem;
  margin-bottom: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.blkRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.8rem;
}
.field {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
}
.field input {
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 0.4rem;
  font-size: 0.8rem;
}
.field.reason input {
  width: 16rem;
}
.segLabel {
  align-self: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
  margin-right: 0.4rem;
}
.chips {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.chip {
  height: 28px;
  min-width: 2.6rem;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: white;
  font-size: 0.75rem;
  font-weight: 600;
}
.chip.on {
  background: #24333f;
  border-color: #24333f;
  color: white;
}
.linkBtn {
  border: none;
  background: none;
  color: #006498;
  font-size: 0.75rem;
  font-weight: 600;
  text-decoration: underline;
}
.targets {
  border-top: 1px solid #e2e8f0;
  padding-top: 0.6rem;
}
.targetsHead {
  display: flex;
  gap: 0.6rem;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 700;
}
.targetsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
  gap: 0.3rem;
  margin-top: 0.4rem;
}
.pick {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  padding: 0.3rem 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
}
.pick small {
  margin-left: auto;
  color: #64748b;
}
.pick.on {
  border-color: #006498;
  background: #eef6fb;
}
.blkFoot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-top: 1px solid #e2e8f0;
  padding-top: 0.6rem;
}
.blkFoot .summary {
  font-size: 0.82rem;
  color: #1e293b;
}
.acc {
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  margin-bottom: 0.9rem;
  overflow: hidden;
}
.accHead {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.7rem 1rem;
  border: none;
  background: white;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}
.accHead.static {
  cursor: default;
}
.accName {
  font-weight: 700;
  font-size: 0.95rem;
}
.accNote,
.follows {
  font-size: 0.75rem;
  color: #64748b;
}
.caret {
  display: inline-block;
  transition: transform 0.15s;
  color: #64748b;
}
.caret.open {
  transform: rotate(90deg);
}
.tag {
  font-size: 0.7rem;
  font-weight: 700;
  background: #fff7e6;
  color: #9a5b00;
  border-radius: 999px;
  padding: 0.05rem 0.5rem;
}
.tag.own {
  background: #e6f2f8;
  color: #006498;
}
.fitter {
  border-bottom: 1px solid #e2e8f0;
}
.fitter:last-child {
  border-bottom: none;
}
.fitterHead {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1rem;
}
.fitterName {
  border: none;
  background: none;
  font-weight: 600;
  font-size: 0.88rem;
  padding: 0;
  color: #1e293b;
}
.fitterName:disabled {
  cursor: default;
  color: #1e293b;
}
.fitterName .inactive {
  color: #94a3b8;
  font-weight: 400;
}
.switch {
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}
.hoursTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}
.hoursTable th {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  padding: 0.4rem 0.6rem;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}
.hoursTable td {
  padding: 0.3rem 0.6rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.hoursTable tr.extraShift td {
  border-top: none;
}
.hoursTable tr.override td {
  background: #fff7e6;
}
.hoursTable tr.closed td {
  color: #64748b;
}
.hoursTable .cDay {
  width: 4rem;
  font-weight: 700;
}
.hoursTable .cDate {
  width: 6.5rem;
  font-variant-numeric: tabular-nums;
}
.hoursTable .cTime {
  width: 8.5rem;
}
.hoursTable .cClosed {
  width: 4.5rem;
  text-align: center;
}
.hoursTable .cAct {
  white-space: nowrap;
}
.hoursTable input[type=time],
.hoursTable .reason {
  height: 28px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 0.4rem;
  font-size: 0.8rem;
}
.hoursTable .reason {
  width: 100%;
  max-width: 22rem;
}
.actRow {
  display: flex;
  gap: 0.3rem;
  justify-content: flex-end;
}
.actRow button {
  height: 26px;
  padding: 0 0.55rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: white;
  font-size: 0.72rem;
  font-weight: 600;
  color: #334155;
}
.actRow button:disabled {
  opacity: 0.4;
}
.actRow button:hover:not(:disabled) {
  background: #f1f5f9;
}
.actRow .preset.on {
  background: #24333f;
  border-color: #24333f;
  color: white;
}
.actRow .shiftAdd {
  border-style: dashed;
}
.toastMessage {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translate(-50%, 1rem);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s, transform 0.15s;
  z-index: 1001;
  background: #1e293b;
  color: white;
  padding: 0.6rem 1rem;
  border-radius: 0.4rem;
  font-size: 0.85rem;
  max-width: 36rem;
}
.toastMessage.on {
  opacity: 1;
  transform: translate(-50%, 0);
}
/*# sourceMappingURL=scheduler-hours.component.css.map */
